import { useContext, useEffect, useState } from "react";
import { GoBackButton, MagicButton, StandardButton } from "../atoms/buttons";
import { LessonStepBar } from "../components/lessonStepBar";

import { Difficulty, TitleDescription, TitleFunction } from "../components/titleDescription";

import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { QuizStepper, QuizStepperNew } from "../components/quizStepper.js";
import { getAPI, postAPI, updateAPI,fetchAPI } from "../api/api.js";
import Review from "./review.js";
import { PageContext, UserContext } from "../App.js";
import { SelectImageComp } from "../molecule/selectImageComp.js";
import { ImageSelectorModalCopy, EditCourseModal, ScoreOverviewModal } from "../components/customModals.js";
import { PublishNavigation } from "../molecule/publishMenuBar.js";
import { CourseSettingComp } from "../components/courseSettingsComp.js";
import { icon } from "../functions/icons.js";
import { Alert } from "../components/alert.js";
import { set } from "date-fns";
import { HeaderTitle } from "../molecule/headerTitle.js";
import { Modal, ModalBody, ModalTitle } from "../components/modal.js";
import { ToggleSwitch } from "../molecule/ToggleSwitch.js";
import { TitleAtom } from "../atoms/titleAtom.js";
import { margin } from "polished";
import { Spinner } from "../atoms/spinner.js";
import { TitleAction } from "../molecule/TitleAction.js";
import PublishCourseComp from "../components/PublishCourseComp.js";


export function PublishCourse({ publish, pageSwap, course, start }) {
  const [courseData, setCourseData] = useState([])
  const [activeModal, setActiveModal] = useState(false)
  const [quizStructure, setCourseStructure] = useState([])
  const [activeCourseSetting,setActiveCourseSettings] = useState(false)
  const [errorMessage, setErrorMessage] = useState("");
  const [description, setDescription] = useState(null);
  const navigationContext = useContext(PageContext)
  const userContext = useContext(UserContext);
  const [editCourseInfo, setEditCourseInfo] = useState(false)
  const [userAvatar, setUserAvatar] = useState(null);
  // const [creditValue, setCreditValue] = useState(0)
  const [deactivateVisible, setDeactivateVisible] = useState(false);

  const [exercises, setExercises] = useState([]);
  const courseId = navigationContext.sidebar.courseID;
  const userId = navigationContext.sidebar.userId  
  const [errorScoreMessage, setErrorScoreMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [aiLoading,setAiLoading] = useState(false);
  const [scoreModalVisible, setScoreModalVisible] = useState(false);
  useEffect(() => {
    console.log(navigationContext.sidebar.userId)
    loadCurrentCourse()
    loadCurrentCourseStucture()
    // if(!courseData?.published){
    //   loadCreditValue()
    // }
    loadAssessmentOverview()
  }, [])
  
  useEffect(() => {
    if (navigationContext.sidebar.userId !== 0 && navigationContext.sidebar.userId !== "@me") {
      fetchUserData();
    }
  }, [navigationContext.sidebar.userId]);

  const loadCurrentCourseStucture = async () => {
    setLoading(true);
    const userId = navigationContext.sidebar.userId === 0 ? "@me" : navigationContext.sidebar.userId;
    const query = `api/courses/lessons/${courseId}/structure?user=${userId}`;
  
    const load = await getAPI(query);
    console.log("loaddata",load.data)
    if (load.data.length > 0) {
      const updatedStructure = load.data.map((row) => ({
        ...row,
        collapsed: false,
      }));
      setCourseStructure(updatedStructure);
      return;
    }
    setCourseStructure([]);
    setLoading(false);
  };
  const loadCurrentCourse = async () => {
    const query = `api/courses/${courseId}`
    const load = await getAPI(query)
    if (load.status === "ok") {
      setCourseData(load.data[0])
      return
    }
    setCourseData([])
  }

  const validateLessons = () => {
    const emptyLessons = quizStructure.filter(lesson => 
      !lesson.title || 
      !lesson.description || 
      !lesson.module_content || 
      lesson.module_content.trim() === ""
  );

  if (emptyLessons.length === 0) {
      setErrorMessage("Je mist les title, inhoud of beschrijving.");
      return false; 
  }
  return true;
  };
  

  const publishLesson = async () => {
    if (!validateLessons()) {
      return;
    }
    const query = "api/courses/publish"
    const body = {}
    body["id_course"] = courseId
    body["image_url"] = courseData?.image_url
    await updateAPI(query, body)
    navigationContext.handleNavigation({ courseID: 0, navigation: 2, enrollment: 0 })
  }
  const startCourse = async () => {
    const query = "api/assessments/start-assessment"
    const body = {}
    body["id_course"] = courseId

    const post = await postAPI(query, body)
    if (post.status === "ok") {
      navigationContext.handleNavigation({ courseID: courseId, navigation: 10, enrollment: post.data })
    }
  }

  // const loadCreditValue = async () => {
  //   const query = `api/courses/${navigationContext.sidebar.courseID}/credits`
  //   const credits = await getAPI(query)
  //   console.log(credits)
  //   setCreditValue(credits.data[0].credits)

  //   }
  const handleCollapse = (index) => {
    const copyStructure = [...quizStructure]
    copyStructure[index].collapsed = !copyStructure[index].collapsed
    setCourseStructure(copyStructure)

  }
  const openSelector = () => {
    setActiveModal(!activeModal)
  }

  const selectImage = (value) => {
    const copyCourse = { ...courseData }
    copyCourse.image_url = value.image.url
    
    setCourseData(copyCourse)
    openSelector()


  }
  const handleDepartment = (value, index) => {
    var copy = { ...courseData }
    copy.departments = [...copy.departments]
    copy.departments[index].selectedValue = value
    setCourseData(copy)
  }
  const addDepartment = (value) => {
    var copyCourseData = { ...courseData }
    if (copyCourseData?.departments) {
      copyCourseData.departments = [...courseData.departments, { "selectedValue": value }]
      console.log(copyCourseData)
      setCourseData(copyCourseData)
      return
    }
    copyCourseData.departments = [{ "selectedValue": value }]
    console.log(copyCourseData)
    return setCourseData(copyCourseData)
  }
  const handleGoBack = () => {
    const { courseID } = navigationContext.sidebar;
    const isPublished = courseData?.published;
    if (isPublished) {
      const targetNavigation =  navigationContext.sidebar?.back_page || 2;
      navigationContext.handleNavigation({ courseID: 0, navigation: targetNavigation, enrollment: 0, back_page: null, userId:0 });
    } else {
      const targetNavigation = courseID && courseID !== 0 ? 5 : 2;
      navigationContext.handleNavigation({ courseID, navigation: targetNavigation, enrollment: 0, back_page: null, userId:0 });
    }
  };
  const renderUserProgress = () => {
    const userId = navigationContext.sidebar.userId;
    console.log("show:", userId);
    if (userId === 0 || userId === "@me") {
      return
    } else {
      return userAvatar;  
    }
  };
const fetchUserData = async () => {
  const user_information = await fetchAPI(`api/users/${navigationContext.sidebar.userId}`);
  if (user_information.details) {
    const userName = user_information.details.full_name;
    console.log(userName);
    setUserAvatar(
      <img
        className="rounded-img"
        style={{ height: "4rem", width: "4rem", margin: "0px 0px 0.5rem 0px" }}
        src={`https://ui-avatars.com/api/?name=${userName}&background=random&color=fff&format=svg`}
        alt={`${userName} Avatar`}
      />
    );
  }
};
const [pendingToggleState, setPendingToggleState] = useState(null);
const isPublished = courseData?.published === 1;
const isDeactivated = courseData?.published === 2;
console.log(courseData)
const reactivateCourse = async () => {
  const query = 'api/courses/activate'; 
  const body = { id_course: courseId };
  const res = await updateAPI(query, body);
  if (res.status === 'ok') {
    await loadCurrentCourse();
    setDeactivateVisible(false);
  } else {
    setErrorMessage("Activeren mislukt!");
  }
};
const deactivateCourse = async () =>{
  const query = 'api/courses/deactivate';
  const body = {id_course : courseId};
  const res = await updateAPI(query, body)
  if (res.status === 'ok'){
    await loadCurrentCourse();
    setDeactivateVisible(false);
  }else
  setErrorMessage("Deactiveren mislukt!")
}
const deleteCourse = async () =>{
  const query = 'api/courses/delete';
  const body = {id_course : courseId};
  const res = await updateAPI(query, body)
  if (res.status === 'ok'){
    navigationContext.handleNavigation({ courseID: 0, navigation: 2, enrollment: 0 });
  }else
  setErrorMessage("Verwijder van cursus mislukt!")
}
const handleTogglePublish = (newState) => {
  setPendingToggleState(newState);
  setDeactivateVisible(true);
};

  const loadAssessmentOverview = async () => {
      setLoading(true)
      let query = `api/assessments/overview?course=${courseId}&user=${userId === 0 ? "@me":userId}`
      const load = await getAPI(query)
      console.log("data is:",load.data," and id:",userId)
      console.log("res: ",load)
      if (load.data.length < 1){
          setErrorScoreMessage((userId === 0 || userId === "@me") ? "Er is nog geen score-overzicht beschikbaar voor jouw, begin met leren." : "Deze gebruiker heeft nog geen score-overzicht.")  
          setExercises([]);
      }       
      else{
          setErrorScoreMessage("")
          setExercises(load.data)
      }
      setLoading(false)
          
  }

  if (loading) {
    return <VerticalPageLayout style={{ justifyContent: "center", }}><Spinner size="5rem" thickness="2px" color="primary-600" /></VerticalPageLayout>;
  }
  return (
    <VerticalPageLayout className={`page-in-animation ${pageSwap && "page-out-animation"}`}>
      <VerticalLayout className="standard-padding" style={{ width: "unset" }}>
        <HorizontalLayout className="space-between">
          <HorizontalLayout className="phone-cursus-header">
            <GoBackButton
              title={""}
              left={true}
              color={"black-color semi-bold"}
              className={'goback-button go-back-btn'}
              goBack={handleGoBack}
            />
            <TitleAtom title={courseData?.title} />
            <div className="user-info"> {renderUserProgress()} </div>
          </HorizontalLayout>
         {(isPublished || isDeactivated) && ( <ToggleSwitch className={"standard-margin"} checked={courseData?.published === 1} onChange={handleTogglePublish} />)}
        </HorizontalLayout>
        <PublishCourseComp 
          setScoreModalVisible={setScoreModalVisible}
          loadCourse={loadCurrentCourse}
          description={description}
          aiLoading={aiLoading}
          loading={loading}
          courseData={courseData}
          quizStructure={quizStructure}
          activeModal={activeModal}
          selectImage={selectImage}
          openSelector={openSelector}
        />
        <MenuOverviewQuiz
          handleCollapse={handleCollapse}
          quizStructure={quizStructure}
          courseData={courseData}
        />
      </VerticalLayout>
      <ScoreOverviewModal exercises={exercises} published={true} visible={scoreModalVisible} onDismiss={() => setScoreModalVisible(false)} />
      {deactivateVisible && (<DeactivateCourseModal pendingToggleState={pendingToggleState}courseData={courseData} isPublished={isPublished} deactivateVisible={deactivateVisible} deleteCourse={deleteCourse} isDeactivated={isDeactivated} deactivateCourse={deactivateCourse} reactivateCourse={reactivateCourse} setDeactivateVisible={(value) => setDeactivateVisible(value)} courseTitle={courseData?.title}/>)}
    </VerticalPageLayout>
  

  )
}







const MenuOverviewQuiz = ({ handleCollapse, quizStructure,courseData}) => {
  return (
    <VerticalLayout className={`standard-margin-top publish-stepper ${courseData?.published === 2 ? "inactive" : ""}`} style={{ width: "auto", gap: ".7rem",}}>
        <TitleAtom className={"standard-margin-top screen-title"} title={"Cursusoverzicht"} />
        <QuizStepper style={{ "margin": "0.5rem 0px" }}
          type="publish"
          activeSection={-1}
          goToSection={(index) => console.log(index)}
          quizStructure={quizStructure}
          toggleCollapse={handleCollapse}  />
    </VerticalLayout>

  )
}

const DeactivateCourseModal = ({deactivateVisible, setDeactivateVisible, deactivateCourse, courseTitle, reactivateCourse, courseData, deleteCourse, pendingToggleState}) => {

  const isDeleteMode = courseData.published === 0;
  const willActivate = pendingToggleState === true && courseData?.published === 2;
  const willDeactivate = pendingToggleState === false && courseData?.published === 1;
  return(
    <Modal
  dismissable={() => setDeactivateVisible(false)}
  visible={deactivateVisible}
  size="small"
  content={
    <>
      <ModalTitle
        dismissable={() => setDeactivateVisible(false)}
        hasXmark={true}
        title={isDeleteMode ? "Cursus verwijderen" : willActivate ? "Activeer cursus" : willDeactivate ? "Cursus deactiveren": ""} />
      <ModalBody
        style={{ maxWidth: "400px" }}
        content={
          <>
            <p className="standard-margin-bottom">
               {isDeleteMode ? (  <>Weet u zeker dat u de cursus <b>{courseTitle}</b> wilt <b>verwijderen</b>? Deze actie kan niet ongedaan gemaakt worden.</>
                  ) : willActivate ? ( <>Weet u zeker dat u de cursus <b>{courseTitle}</b> wilt <b>activeren</b>? De cursus wordt opnieuw zichtbaar voor gebruikers.</>
                  ) : ( <>Weet u zeker dat u de cursus <b>{courseTitle}</b> wilt <b>deactiveren</b>? De cursus zal niet langer zichtbaar zijn voor gebruikers.</> )}
            </p>
            <HorizontalLayout style={{ justifyContent: "space-between", gap: "1rem" }}>
              <StandardButton
                className="secondary-button"
                title="Nee, annuleer"
                onClick={() => setDeactivateVisible(false)}
              />
               {isDeleteMode ? (
                    <StandardButton
                      backgroundColor="error-600"
                      title="Ja, verwijder"
                      onClick={() => {
                        deleteCourse();
                        setDeactivateVisible(false);
                      }}
                    />
                  ) : willActivate ? (
                    <StandardButton
                      backgroundColor="success-600"
                      title="Activeer cursus"
                      onClick={() => {
                        reactivateCourse();
                        setDeactivateVisible(false);
                      }}
                    />
                  ) : (
                    <StandardButton
                      backgroundColor="error-600"
                      title="Ja, deactiveer"
                      onClick={() => {
                        deactivateCourse();
                        setDeactivateVisible(false);
                      }}
                    />
                  )}
            </HorizontalLayout>
          </>
        }
      />
    </>
  }
/>

  )
}